import * as Sentry from '@sentry/angular';
import { shouldIgnoreReplay } from './sentry.ignore-error-replays';


export function getSentryIntegrations() {
  return [
    Sentry.browserTracingIntegration({
      enableInp: true,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
      maxReplayDuration: 60_000, // 5 minutes maximum recording duration
      beforeErrorSampling: (event) => {
        // Usar la función centralizada de filtrado
        if (shouldIgnoreReplay(event)) {
          return false; // No grabar replay
        }

        // Grabar replay para todo lo demás
        return true;
      },
    }),
  ];
}
